import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import PreviewBrief from '../BriefPreview';
import { processProjectsData, processProjectsAndBriefs, formatDate, processQuote, financialCalculations, formatCash } from '../../../utils/sharedFunctions';
import './style.scss';

const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const MoveFoward = `${process.env.REACT_APP_CDN_URL}/globalAssets/Audit/MoveFoward.svg`;
const MoveBackward = `${process.env.REACT_APP_CDN_URL}/globalAssets/Audit/MoveBackward.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;
var mobile = require('is-mobile');

const Audit = observer(() => {
    
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [YearsContainer, setYearsContainer] = useState([]);
    const [startIndex, setStartIndex] = useState(0);
    const [Briefs, setBriefs] = useState([]);
    const [YearSelected, setYearSelected] = useState('2019/2020');
    const [AvailBriefs, setAvailBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [OfferingFilter, setOfferingFilter] = useState('A-Z');
    const [ServiceCategoryFilter, setServiceCategoryFilter] = useState('A-Z');
    const [ContractTypeFilter, setContractTypeFilter] = useState('A-Z');
    const [JobStatusFilter, setJobStatusFilter] = useState('A-Z');
    const [FulfillmentLeadFilter, setFulfillmentLeadFilter] = useState('A-Z');
    const [MonthFilter, setMonthFilter] = useState('A-Z');
    const [ViewBrief, setViewBrief] = useState(false)
    const [SelectedProject, setSelectedProject] = useState({});
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [BriefPayment2Open, setBriefPayment2Open] = useState(-1);
    useEffect(() => {
        getBriefs();
    }, []);

    const getBriefs = async () => {
        
        store.setLoading(true);
        try {
            await getYears();
            const [users, briefs, projPlans, evaluation, projects, quotes, vouchers] = await Promise.all([
                store.getUsers(),
                store.getBriefs(),
                store.getProjectPlans(),
                store.getEvaluation(),
                store.getProjects(),
                store.getQuote(),
                store.getVouchers()
            ]);

            const prosAndLeads = {
                Leads: users.filter(user => user.roles?.[0] === 1987),
                Pros: users.filter(user => user.roles?.[0] === 1988),
                Clients: users.filter(user => user.roles?.[0] === 1989)
            };
            const confirmedBriefs = briefs.filter(item => item.client && item.talentPartner && item.projectPlan);
            let processedBriefs = processProjectsData(
                confirmedBriefs,
                projPlans,
                projects,
                evaluation,
                vouchers,
                quotes,
                prosAndLeads
            );
            const processProject_Brief = processProjectsAndBriefs(projects, processedBriefs, prosAndLeads.Leads, evaluation, prosAndLeads.Clients, projPlans)

            setAvailBriefs(processProject_Brief.processedProjects ?? []);
            setProfessionals(prosAndLeads.Pros);
            setLeads(prosAndLeads.Leads);
            filterByYear(YearSelected, processProject_Brief.processedProjects ?? []);
            setBriefs(processProject_Brief.processedProjects ?? []);
            forceUpdate();
        } catch (e) {
            console.error(e);
        } finally {
            store.setLoading(false);
        };
    };

    const getYears = async () => {
        const currValue = '2019/2020';
        const [startYear, endYear] = currValue.split('/').map(Number);
        const yearsArray = [];

        for (let i = 0; i < 15; i++) {
            yearsArray.push(`${startYear + i}/${endYear + i}`);
        }

        setYearsContainer(yearsArray);
        forceUpdate();
    };

    const handleForward = () => {
        if (startIndex + 5 < YearsContainer.length) {
            setStartIndex(startIndex + 1);
        }
    };
    const handleBackward = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    const filterByYear = (e, Briefs) => {
        let selectedYear = e;
        const [year1, year2] = selectedYear.split("/");
        var filteredBriefs = [];

        if (Briefs === 'error') {
            setBriefs([]);
        } else {
            filteredBriefs = Briefs.filter((item) => {
                let newDate = new Date(item.createdAt);
                if (!isNaN(newDate.getTime())) {
                    const itemYear = newDate.getFullYear().toString();
                    return itemYear === year1 || itemYear === year2;
                };
            });
        };
        const AvailBriefs = filteredBriefs.filter(brief => {
            const searchValue = searchTerm
            return (
                brief?.title?.toLowerCase().includes(searchValue) ||
                (brief?.client?.lastName?.toLowerCase().includes(searchValue) || brief?.client?.email?.toLowerCase().includes(searchValue))
            );
        });
        setAvailBriefs(AvailBriefs);
        setYearSelected(selectedYear);
        forceUpdate();
    };
    const handleTitleFilterComps = (e) => {
        let sortedBriefs = [...Briefs];
        const id = e.target.id.toLowerCase();

        const sortBriefs = (property, stateUpdater, isNested = false) => {
            stateUpdater(prev => {
                const isAscending = prev === 'A-Z';
                sortedBriefs.sort((a, b) => {
                    // Handle nested object properties
                    const valA = isNested ? a[property]?.fullName : a[property];
                    const valB = isNested ? b[property]?.fullName : b[property];

                    // Handle null/undefined values
                    if (!valA && !valB) return 0;
                    if (!valA) return 1;
                    if (!valB) return -1;

                    return isAscending
                        ? valB.toString().localeCompare(valA.toString())
                        : valA.toString().localeCompare(valB.toString());
                });

                setBriefs(sortedBriefs);
                const filtered = sortedBriefs.filter(brief => {
                    const searchValue = searchTerm.toLowerCase();
                    return (
                        brief?.title?.toLowerCase().includes(searchValue) ||
                        brief?.client?.lastName?.toLowerCase().includes(searchValue) ||
                        brief?.client?.email?.toLowerCase().includes(searchValue)
                    );
                });
                setAvailBriefs(filtered);

                return isAscending ? 'Z-A' : 'A-Z';
            });
        };

        switch (id) {
            case 'offering':
                sortBriefs('servicesOffered', setOfferingFilter);
                break;
            case 'servicecategory':
                sortBriefs('serviceCategory', setServiceCategoryFilter);
                break;
            case 'contracttype':
                sortBriefs('contractType', setContractTypeFilter);
                break;
            case 'jobstatus':
                sortBriefs('briefStatus', setJobStatusFilter);
                break;
            case 'fulfillmentlead':
            case 'fulfilmentlead':
                sortBriefs('talentPartner', setFulfillmentLeadFilter, true); // Added true for nested property
                break;
            case 'month':
                setMonthFilter(prev => {
                    const isAscending = prev === 'A-Z';
                    sortedBriefs.sort((a, b) => {
                        if (!a.createdAt || !b.createdAt) return 0;
                        return isAscending
                            ? b.createdAt.localeCompare(a.createdAt)
                            : a.createdAt.localeCompare(b.createdAt);
                    });
                    setBriefs(sortedBriefs);
                    setAvailBriefs(sortedBriefs.filter(brief => {
                        const searchValue = searchTerm.toLowerCase();
                        return (
                            brief?.title?.toLowerCase().includes(searchValue) ||
                            brief?.client?.lastName?.toLowerCase().includes(searchValue) ||
                            brief?.client?.email?.toLowerCase().includes(searchValue)
                        );
                    }));
                    return isAscending ? 'Z-A' : 'A-Z';
                });
                break;
        }
    };
    const handleSearchChange = (e) => {
        let briefs = [...Briefs];
        briefs = briefs.filter((item) => {
            if (item.hasOwnProperty('title')) {
                return item.title.includes(e.target.value)
            };
        });
        setAvailBriefs(briefs)
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    function getDaysDifference(date1, date2) {
        const [day1, month1, year1] = date1.split('/').map(Number);
        const [day2, month2, year2] = date2.split('/').map(Number);
        const firstDate = new Date(year1, month1 - 1, day1);
        const secondDate = new Date(year2, month2 - 1, day2);
        const diffTime = Math.abs(secondDate - firstDate);

        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };
    function handleGotoPreview(item) {
        setSelectedProject(item);
        setBriefPayment2Open(-1)
        setViewBrief(true);
    }
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            getBriefs();
        };
        setViewBrief(back);
        forceUpdate();
    };
    const CurrentYearsArray = YearsContainer.slice(startIndex, startIndex + 5);
    function handlerPaymentEnter(e) {
        setBriefPayment2Open(e.currentTarget.id)
    }
    function handlePaymentLeave() {
        setBriefPayment2Open(-1)
    }

    if (mobile()) {
        return (
            <div>

            </div>
        );
    } else {
        return (
            <div className='AuditPage'>
                <div className='AuditPageHeader'>
                    <p>Audit</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>

                {ViewBrief ? (
                    <div style={{ width: "100%", height: "88%" }}>
                        <PreviewBrief project={SelectedProject} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                    </div>
                ) : (
                    <div className='AuditPageBody'>
                        <div className='headerFilterSection'>
                            <p style={{ width: '11%', fontWeight: '700', fontSize: '24px' }}>Project List</p>
                            <div className='numofItems'>
                                <p className='spancular'>{AvailBriefs.length}</p>
                            </div>
                            <div className='filterBriefsSection'>
                                <div className='search-bar-section' style={{ backgroundColor: '#F5F6FA', width: '45%' }}>
                                    <img src={SearchIcon} alt='Search Icon' />
                                    <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange}></input>
                                </div>
                            </div>
                        </div>
                        <div className='briefSect'>
                            <div className='availProjectsHeaderContainer'>
                                <p style={{ minWidth: '200px' }}>Client Name</p>
                                <p style={{ minWidth: '200px' }}>Job Number</p>
                                <div className='monthFilterSection' style={{ cursor: "pointer" }}>
                                    <p id='month' onClick={handleTitleFilterComps}>Month</p>
                                    <img src={MonthFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer', display: 'block' }} id='Month' onClick={handleTitleFilterComps} />
                                </div>
                                <p style={{ minWidth: '200px' }}>Project Name</p>
                                <div className='offeringFilterSection'>
                                    <p onClick={handleTitleFilterComps} id='offering'>Offering</p>
                                    <img src={OfferingFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='Offering' onClick={handleTitleFilterComps} />

                                </div>
                                <div className='serviceCategoryFilterSection'>
                                    <p id='serviceCategory' onClick={handleTitleFilterComps}>Service Category</p>
                                    <img src={ServiceCategoryFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ServiceCategory' onClick={handleTitleFilterComps} />

                                </div>

                                <p style={{ minWidth: '200px' }}>Service Provider(s)</p>
                                <p style={{ minWidth: '200px' }}>No. of Professionals</p>
                                <div className='fulfillmentLeadFilterSection'>
                                    <p id='fulfilmentLead' onClick={handleTitleFilterComps} >Fulfillment Lead</p>
                                    <img src={FulfillmentLeadFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='FulfillmentLead' onClick={handleTitleFilterComps} />

                                </div>
                                <div className='contractTypeFilterSection'>
                                    <p id='contractType' onClick={handleTitleFilterComps} >Contract Type</p>
                                    <img src={ContractTypeFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ContractType' onClick={handleTitleFilterComps} />

                                </div>

                                <p style={{ minWidth: '200px' }}>Contract Signed</p>
                                <p style={{ minWidth: '200px' }}>Job Amount</p>
                                <p style={{ minWidth: '200px' }}>Professional Fees</p>
                                <p style={{ minWidth: '200px' }}>Credipple Fee</p>
                                <p style={{ minWidth: '200px' }}>Contract Duration</p>
                                <p style={{ minWidth: '200px' }}>Invoice Number(s)</p>
                                <p style={{ minWidth: '200px' }}>Purchase Order</p>
                                <p style={{ minWidth: '200px' }}>Voucher ID</p>
                                <div className='jobStatusFilterSection'>
                                    <p id='jpbStatus' onClick={handleTitleFilterComps}>Job Status</p>
                                    <img src={JobStatusFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='JobStatus' onClick={handleTitleFilterComps} />
                                </div>

                                <p style={{ minWidth: '200px' }}>Project Start Date</p>
                                <p style={{ minWidth: '200px' }}>Fulfillment Stage</p>
                                <p style={{ minWidth: '250px' }}>Payment Milestone</p>
                                <p style={{ minWidth: '450px' }}>Milestone Payment for Weekly Payment Runs (Yes/No)</p>
                                <p style={{ minWidth: '200px' }}>Next Payment Date</p>
                                <p style={{ minWidth: '200px' }}>Next Payment Amount</p>
                                <p style={{ minWidth: '400px' }}>Credipple Fees Withheld for Professionals (Pre)</p>
                                <p style={{ minWidth: '250px' }}>Project Payments Made</p>
                                <p style={{ minWidth: '200px' }}>Evaluation completed</p>
                                <p style={{ minWidth: '250px' }}>Customer experience rating %</p>
                                <p style={{ minWidth: '300px' }}>Credipple Fees for Professionals (Post)</p>
                                <p style={{ minWidth: '200px' }}>Account Balance</p>
                                <p style={{ minWidth: '200px' }}>Project End Date</p>
                                <p style={{ minWidth: '200px' }}>Project Duration</p>
                            </div>
                            <div className='availProjectsBodyContainer'>
                                {AvailBriefs.map((item, index) => {
                                    // let quotes  = processQuote(item)
                                    if (item?.brief?.projectPlan[0]?.professional?._id) {
                                        let pro = item?.brief?.projectPlan[0]?.professional;
                                        let processedQuote = processQuote(item?.brief, pro);
                                        let Finance = financialCalculations(processedQuote.totalPayable, item?.brief)
                                        return (
                                            <div className='briefCArd' key={index} onClick={() => handleGotoPreview(item)} style={{ cursor: 'pointer' }}>
                                                <p style={{ overflow: 'hidden', minWidth: '195px', maxWidth: '200px' }}>{item?.client?.firstName ?? ''} {item?.client?.lastName ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.referenceNumber ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{formatDate(item?.createdAt) ?? '090/000/0000'}</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.title ?? item?.title ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{Array.isArray(item?.servicesOffered) ? item.servicesOffered[item.servicesOffered.length - 1] : item?.servicesOffered ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{Array.isArray(item?.serviceCategory) ? item.serviceCategory[item.serviceCategory.length - 1] : item?.serviceCategory ?? ''}</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{`${item?.brief.projectPlan[0]?.professional?.firstName ?? ''} ${item?.brief.projectPlan[0]?.professional?.lastName ?? ''}`}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.brief.projectPlan[0]?.professional?.firstName ? 1 : 0}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{`${item?.brief?.talentPartner?.firstName} ${item?.brief?.talentPartner?.lastName}`}</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.contractType ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.brief?.documents[0].acceptedBy?.length > 1 ? 'Yes' : 'No'}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>ZAR {formatCash(processedQuote.totalPayable + (processedQuote.totalPayable * 0.10)) ?? 0}</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>ZAR {formatCash(processedQuote.totalPayable)}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>ZAR {formatCash(Finance?.CredFee10)}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{getDaysDifference(formatDate(item?.brief.projectPlan[0]?.projStartDate), formatDate(item?.brief.projectPlan[0]?.projEndDate))} days</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.finance && Array.isArray(item?.finance?.invoice) ? item.finance.invoice.join(', ') : 'No invoices available'}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.finance?.puechaseOrder ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.voucherNumber ?? ''}</p>

                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item?.briefStatus.toLowerCase() ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{formatDate(item?.brief.projectPlan[0]?.projStartDate) ?? ''}</p>
                                                <p style={{ overflow: 'hidden', minWidth: '200px', maxWidth: '200px' }}>{item.brief.projectPlan[0]?.fulfillmentStage ?? ''}</p>
                                                {Array.isArray(item?.brief?.quote) && item?.brief?.quote.length > 0 &&
                                                    <p style={{ overflow: 'hidden', minWidth: '250px', maxWidth: '200px' }}>{item?.brief?.quote[item?.brief?.quote?.length - 1]?.milestone ?? ''}</p>
                                                }
                                                <p style={{ overflow: 'hidden', minWidth: '450px', maxWidth: '200px' }}>{item?.contractType && item.contractType === 'Once Off' || item.contractType === 'Once-Off' || item.contractType === 'Once-off' || item.contractType === 'Once off' ? 'Yes ' :
                                                    // item?.contractType && item.contractType === 'Fixed Term' || item.contractType === 'fixed-term' || item?.contractType && item.contractType === 'Short Term' && 
                                                    'No'
                                                }
                                                </p>

                                                <p className='nextPaymentcover' id={index} onMouseEnter={handlerPaymentEnter} onMouseLeave={handlePaymentLeave} >
                                                    {Number(BriefPayment2Open) !== -1 ?
                                                        Number(BriefPayment2Open) === index ?
                                                            item.quote.length > 0 ?
                                                                <div className='paymentHover'>
                                                                    <p style={{ width: '98%', display: 'flex', margin: '0px', flexDirection: 'row', fontSize: "14px", minHeight: '0px', margin: '1px 0px', height: '25%', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                                        <span style={{ width: '51%' }}>{formatDate(item.quote[0].depositDueDate) ?? ''}</span>
                                                                        <span style={{ width: '48%' }}>{Number(item.quote[0].deposit) > 0 ? `ZAR  ${formatCash(item.quote[0].deposit)}` : ''}</span>
                                                                    </p>
                                                                    {item.quote[0].selectedPaymentPlan !== '2(50/50)' ?
                                                                        <p style={{ width: '98%', display: 'flex', margin: '0px', flexDirection: 'row', fontSize: "14px", minHeight: '0px', margin: '1px 0px', height: '25%', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                                            <span style={{ width: '51%' }}>{formatDate(item.quote[0].secondPaymentDueDate) ?? ''}</span>
                                                                            <span style={{ width: '48%' }}>{Number(item.quote[0].secondPayment) > 0 ? `ZAR  ${formatCash(item.quote[0].secondPayment)}` : ''}</span>
                                                                        </p>
                                                                        : null
                                                                    }
                                                                    <p style={{ width: '98%', display: 'flex', margin: '0px', flexDirection: 'row', fontSize: "14px", minHeight: '0px', margin: '1px 0px', height: '25%', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                                        <span style={{ width: '51%' }}>{formatDate(item.quote[0].finalPaymentDueDate) ?? ''}</span>
                                                                        <span style={{ width: '48%' }}>{Number(item.quote[0].finalPayment) > 0 ? `ZAR  ${formatCash(item.quote[0].finalPayment)}` : ''}</span>
                                                                    </p>
                                                                </div>
                                                                : null
                                                            : null
                                                        : null
                                                    }
                                                    <p style={{ minWidth: '49%' }} >{item?.brief?.quote.length > 0 ? formatDate(item?.brief?.quote[0].finalPaymentDueDate) ?? '' : ''} </p>
                                                    <p style={{ minWidth: '49%' }}>{item?.brief?.quote.length > 0 ? Number(item?.brief?.quote[0].finalPayment) > 0 ? `ZAR  ${formatCash(item?.brief?.quote[0].finalPayment)}` : '' : ''}</p>
                                                </p>

                                                <p style={{ minWidth: '400px' }}>{`ZAR ${item.evaluation.clientEvaluation.client_summary.credipple_rating > 79 ? formatCash(Finance.CredFee10 * 0.5) : formatCash(Finance.CredFee10)}`}</p>
                                                <p style={{ minWidth: '250px' }}>{item?.payments?.invoiceNumbers?.length?? 0}</p>
                                                <p style={{ minWidth: '200px' }}>{item?.evaluation?.professionalEvaluation.state === 'completed' ? 'YES' : 'NO'}</p>
                                                <p style={{ minWidth: '250px' }}>{item?.evaluation?.clientEvaluation?.client_summary?.credipple_rating ? `${item.evaluation.clientEvaluation.client_summary.credipple_rating}%` : ''}</p>
                                                <p style={{ minWidth: '300px' }}>{item?.finance?.credippleFeesForProfessional ?? ''}</p>
                                                <p style={{ minWidth: '200px' }}>{`ZAR ${formatCash(Finance.Remaining2BPayByClient || 0)}`}</p>

                                                <p style={{ minWidth: '200px' }}>{formatDate(item?.projectPlan[0]?.projEndDate) ?? ''}</p>
                                                <p style={{ minWidth: '200px' }}>{formatDate('')}</p>
                                            </div>
                                        )
                                    }
                                })}
                            </div>

                        </div>

                        <div className='filterByYearSection'>
                            <div className='moveBackwardsBtn' onClick={handleBackward} disabled={startIndex === 0}>
                                <img src={MoveBackward} />
                            </div>
                            <div className='availTabsSection'>
                                {CurrentYearsArray.map((item, index) => (
                                    <div key={index} className='availDatesCard' id={item} onClick={() => filterByYear(item, Briefs)} style={{ backgroundColor: YearSelected === item ? '#6D4194' : '', color: YearSelected === item ? '#fff' : '' }}>
                                        {item}
                                    </div>
                                ))}
                            </div>
                            <div className='moveForwardsBtn' onClick={handleForward} disabled={startIndex + 5 >= YearsContainer.length}>
                                <img src={MoveFoward} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
})

export default Audit;